const Endpoints = {
  // Dashboard
  diffusionDashboard: '/reports/dashboard',

  // Auth
  login: '/auth/login',
  forgotPassword: '/auth/forgotpassword',
  verifyOTP: '/otp/verify',
  resetPassword: '/auth/resetPassword',
  changePassword: '/auth/changePassword', // Change Password on Profile Screen
  reSendOtp: '/otp/resend',
  deactivateSendOTP: '/otp/send-otp',
  deactivateUser: '/users/user/delete',

  // Profile
  getUserProfile: '/users/profile',
  updateUserProfile: '/users/update-profile',
  getUserPermissions: '/users/permissions',

  //Address
  getProfileAddress: '/address/profile',
  address: '/address',

  //location
  getLocation: '/address/locationList',
  getStates: '/address/states',
  getDistricts: '/address/districts',
  getCities: '/address/locations',
  getStatesDistrits: '/address/location-details-by-name',

  //lookup
  getLookup: '/onboarding/lookupList',

  // Training
  trainingModule: '/trainings',

  // Livelihood Training
  livelihoodTrainings: '/trainings',
  uploadfile: '/file/upload',
  getUploadfile: '/file',
  lessonModule: '/trainings/lessons',
  getLessonsByID: '/trainings/lessons/',
  getLessonById: '/trainings/lessonById',

  //Events
  getEvent: '/event',
  createEvent: '/event/create',
  getCalendarEvent: '/event/summary',
  bulkInvite: '/participant-enrollment/invite-participants',
  getBulkInvite: '/participants/invite-participants/',
  eventPhase: '/event/eventPhaseUpdate',
  deleteEvent: '/event/',
  reportEvent: '/event/EventReport',

  //reports
  reportTraining: '/event/Reports',
  reportSurvey: '/reports/surveyReport',
  participantReport: '/reports/participantReport',
  trainingReport: '/participants/trainingReport',

  // survey by id new apis
  surveyListByEventId: '/survey/surveyListByEventId/',
  fetchSurveysAndParticipantsByCondition:
    '/participants/fetch-surveys-and-participants-by-condition',

  // Survey
  surveyModule: '/survey',
  surveyListByTab: '/survey/listSurveyByTab',
  surveyHistory: '/survey/surveyHistory',
  getSurveyByID: '/survey/',
  getSurveyByEventID: '/survey/listByEventId/',
  surveyResponse: '/survey/surveyResponse',
  patchSurveybyID: '/survey/questions/',
  fillSurvey: '/survey/submit-survey',
  insertSurveyResponseFromExcel: '/survey/insertSurveyResponseFromExcel/insert',
  sendSurvey: '/survey/send-to-participants',
  deleteSurvey: '/survey/',
  downloadSurveyTemp: '/event/event-without-participants/',
  downloadSurveySample: '/survey/downloadSurveyResponsesAsExcel/download',
  downloadSurveyAns: '/survey/event-with-participants',
  downloadSurevyResponse: '/survey/download-survey-question-response',
  downloadBulkSurveyResponse: '/survey/download-bulk-survey-responses',
  fillConsentAnswer: '/survey/submit-consent-survey',
  fillConsentSurvey: '/survey/submit-consent-survey',

  //Notification
  notificationList: '/notifications/list',
  markAllAsRead: '/notifications/bulk-mark-read',
  markAsRead: '/notifications/mark-read',

  // Dashboard
  analytics: '/reports/dashboard',
  participantStats: '/reports/participantStats',
  organisationStats: '/onboarding/organisationStats',
  eventsStats: '/reports/eventsStats',
  tvAnalytics: '/reports/dashboard',
  tvDashboardParticipant: '/reports/participantAnalytics',

  //Participants
  getEventById: '/event/',
  participants: '/participants',
  getParticipantCountForEventIds: '/participants/getParticipantCountForEventIds',
  participantEnrollment: '/participant-enrollment/',
  bulkParticipant: '/participant-enrollment/bulk-add',
  getParticipantById: '/participants/',
  deleteParticipant: '/adminuser/participant-enrollment/',

  //FarmerJourney
  farmerData: '/farmerjourney/farmers',
  getEventsListForGivenEventIds: '/event/getEventsListForGivenEventIds',
  farmerUpdateStatus: '/farmerjourney/approval',
  farmerJourney: '/farmerjourney/listAllfarmerJourney',
  parceICNumber: '/participant-enrollment/parseIcNumber',
  fetchUpdatedByUsers: '/users/getUserInfoForIds',

  // Collection Center
  collectioncenter: '/onboarding/collectionCenters',
  createCollectionCenter: '/onboarding/collectionCenters',
  rissGroup: '/audit/list/riss-groups',

  // Organisation
  organisation: '/onboarding/organisation',
  addOrganisation: '/onboarding/organisation',

  // Attendance
  getAttendanceById: '/participants/listAttendance/',
  updateAttendance: '/participants/markAttendance',

  // reportsAnalytics
  reportsAnalytics: '/reportsAndAnalytics/monthlyReport',
  UploadReport: '/file/list-uploaded-reports',
  PostUpload: '/file/upload-reports',

  // Download
  downloadReports: '/reports/export',
  downloadFile: '/downloads/export',
  downloadFileById: '/downloads/',
  getUrlByKey: '/file/',
  researchAttendance: '/participants/export/',
  downloadDataset: '/reports/export-aggregated',

  //TV screen
  getAwaiting: '/trace',
  updateAwaiting: '/trace/update-mpob-mspo/',

  approvalStatus: '/farmer-details/approval-status',
  getPlantation: '/trace-to-plantation',

  //plantation form
  progressTPP: '/trace/progress/',

  //trace to verify
  getTraceVerify: '/trace-to-verify',
  putTraceVerify: '/trace-to-verify/update-farm-status',

  //tv farmer journey
  getFarmerJourney: '/trace/farmer-details/farmerjourney',
  downloadTvFarmerJourney: '/reports/export',
  exportTVData: '/reports/export',

  //get forms
  getFarmerDetails: '/farmer-details/getFarmerDetails/',
  getFarmDetails: '/farm/getFarmDetails/',
  getLabourDetails: '/farm/getLabourDetails/',
  getFFBDetails: '/farmer-details/getFFBDetails/',
  putFFBDetails: '/trace-to-plantation/bulk',

  //documents
  getDocuments: '/trace-to-plantation/farmer-documents/',
  postDocuments: '/trace-to-plantation/upload-docs/',

  postFarmerTrace: '/farmer-details',
  postFarmTrace: '/farm/farmDetails',
  postLabourTrace: '/farm/Updatelabour/bulk',
  generateFarmId: '/farm/generatefarm-id/',

  postTraceStatus: '/trace-to-verify/update-farm-status',

  //super admin
  createUserRole: '/superadmin/roles',
  patchUserRole: '/superadmin/roles/',
  getUserRole: '/superadmin/Listroles',
  getUserRoleById: '/superadmin/role/',
  deleteUserroleId: '/superadmin/roles/',
  bulkUploadUserRole: '/superadmin/roles/upload-excel',
  getPillarsPermissions: '/pillars/permissions',

  getAdminUserDataNew: '/api/users',
  getAdminRoleDataNew: '/api/access-control/roles',

  getUserData: '/superadmin/get-all',
  createUser: '/api/users/create-user',
  getUserById: '/superadmin/',
  patchUserById: '/api/users/',
  blockUserId: '/superadmin/block/',
  bulkUploadUsers: '/superadmin/users/upload-excel',

  //access management
  createRole: '/api/access-control/roles',
  patchRole: '/api/access-control/role/',

  //ttv reports
  getFarmReport: '/reports/farm-data-report',
  deleteFarmByIndex: '/farm/deletefarm/',
  getTvReport: '/reports/ttp-data-report',
  getApproval: '/farmer-details/approval-status',
  updateApprovalStatus: '/farmer-details/tv-approval',
  exportTraceVerify: '/trace-to-verify/export/ttfdata',

  inviteCCevent: '/participants/invite-list',
  getFarmers: '/farmers',
  //CC
  CCtrainingModule: '/training',
  CClessonModule: '/lessons',
  CCgetLessonsByID: '/lessons/listLesson/',

  //dropdown riss
  rissGroupDropdown: '/data-collection/groups/dropdown',

  //CC Assessment (Legacy endpoints - deprecated)
  assessmentRissGroups: '/assessment/riss-groups',
  assessmentGroupParticipants: '/assessment/riss-groups',

  // Livelihood Assessment APIs (New)
  assessmentGroups: '/assessment/groups',
  assessmentGroupsFarmers: '/assessment/groups',
  assessmentFarmerForms: '/assessment/farmers',
  farmerAssessment: '/assessment/farmer-assessment',
  fipTrafficLight: '/assessment/fip-traffic-light',
  assessmentCycle: '/assessment/groups/assessment-cycle',
  createEventCC: '/events',
  eventByDateCC: '/events/calendar',
  eventByDateFilterCC: '/events/events-by-date',
  getISHPotential: '/farmers/ISHPotential',
  getESignsById: '/farmers',
  getCCParticipants: '/participants',
  postCCInvite: '/events/invite-participant',
  attendanceByCCEventID: '/participants/cc/listAttendance/',
  markCCAttendance: '/participants/cc-markAttendance',
  exportCCFarmerJourney: '/reports/export',
  exportTTPReportTVData: '/reports/exportreport',

  // CCDashboard
  ccDashboard: '/reports/CCDashboard',
  ccDashboardParticipant: '/reports/participantAnalytics',

  //CCAproval
  CCApprovallist: '/participants/v2/registration-list',
  CCAuditReviewList: '/participants/filtered-journeys/auditlist',
  CCAuditCompletionList: '/audit/auditCompletionlist',
  // CCAprovallistTraining: '/participants/filtered-training-journeys/approvedlist',
  CCAprovallistTraining: '/participants/v2/training-list',
  CCApprovalRegisterApprove: '/participants/participant-approval',
  CCApprovalTrainingApprove: '/participants/training-approval',

  //datacollection
  ccFarmerParticipantById: '/participants/farmer-participant/',
  getAllDataCollection: '/data-collection',

  getDataCollectionFertilizer: '/farm/fertilizer/',
  postDataCollectionFertilizer: '/farm/fertilizer/create',
  getDataCollectionById: '/data-collection/farmer-documents/',
  postDataCollectionbyid: '/data-collection/upload-docs/',
  getDataCollectionChemical: '/farm/chemical/',
  postDataCollectionChemical: '/farm/chemical/create',
  //Data in Data Collection
  getDetailsOfDatainDataCollection: '/data-collection/CCFarmerProgress',
  getFarmsListOfFarmer: '/data-collection/farmsListOfFarmer',
  getCCFFBDetails: '/farm/ccffbdeatils/',
  postCCFFBDetails: '/farm/ccffbdeatils/create',

  getCCExpenses: '/farm/expense/',
  postCCExpenses: '/farm/expense/create',

  getCCFarm: '/farm/ccFarmDetails/',
  postCCFarm: '/farm/ccFarmDetails',
  getCCSpocAreas: '/data-collection/spoc-areas',

  getCCFarmerDetails: '/data-collection/ccfarmer-details/',
  postCCFarmerDetails: '/data-collection/ccfarmer-details',

  getCCOwnerDetails: '/data-collection/ownership-details/',
  postCCOwnerDetails: '/data-collection/ownership-details',

  //Worker DataCollection
  getWorkedDataBasedonFarm: '/farm/worker/',
  postWorkedDataBasedonFarm: '/farm/worker/saveorupdate',

  putDataCollectionApproval: '/data-collection/ccOverallApproval',

  ccFarmerJourney: '/farmers/farmer_Journey_List',
  ccAuditReviewApproval: '/audit/review-approval',
  ccAuditCompletionApproval: '/audit/completion-approval',

  //reports for cc
  reportsCC: '/reports/CCReports',

  //export cc
  downloadCCEvent: '/cc-exports/export',

  getVerificationData: '/verification/farmers',
  ccFarmerApproval: '/verification/farmers',
  getAuditGroupData: '/audit/riss-groups',
  getAuditParticipantData: '/audit/groups/',
  saveAuditData: '/audit/internal-audits',
  getAuditData: '/audit/internal-audits/',
  exportInternalAudits: '/audit/export-internal-audits/',
  markFarmerAuditStatus: '/audit/mark-audit-status',
  getCCRissGroups: '/audit/riss-groups-list',

  //event module dropdown
  getEventLiModuleDropdown: '/trainings/modules/dropdown',

  //Program Apis
  livelihoodFarmerProgram: '/program/farmers',
  liProgramApprovalnew: '/program/farmers/byProgramCode',
  livelihoodProgram: '/program',
  livelihoodProgramApproval: '/program/approval',
  listApprovals: '/program/ListApprovals',
  listProgramUpdate: '/program/farmApproval',

  listProgramsGetNewByID: '/program/farmProgramData/',
  programsPatchByIDNew: '/program/updateFarmProgram/',

  //Mapping
  farmerMappings: '/farmer/mappings',

  //Events
  livelihoodEvent: '/event',
  livelihoodCreateEvent: '/event/create',
  livelihoodCalendarEvent: '/event/summery',
  postLIInvite: '/event/invite-participant',
  inviteLIevent: '/event/invite-list',
  getEventParticipantInvite: '/farmer/invite-participants/',
  livelihoodParticipants: '/farmer/participants',
  livelihoodEventRegisterApproval: '/farmer/registration-approval',
  livelihoodTrainingApproval: '/farmer/training-completion-approval',

  livelihoodReportList: '/reports',
  livelihoodReportFetch: '/reports',
  livelihoodReportExport: '/reports/exportReport',
  attendanceByLiEventID: '/event/listAttendance/',
  markLIAttendance: '/event/markAttendance',

  //Livelihood Farmer Data Collection
  livelihoodFarmerParticipantById: '/data-collection/participants/farmer-participant/',
  livelihoodFarmerDocuments: '/data-collection/farmer-documents/',
  livelihoodUploadDocuments: '/data-collection/upload-docs/',

  //Livelihood Data Collection Forms
  livelihoodDataCollectionForm: '/data-collection',
  livelihoodDataCollectionForms: '/data-collection/farmers',
  livelihoodDataCollectionProgress: '/data-collection/progress',
  livelihoodDataCollectionGroups: '/data-collection/groups',
  livelihoodDataCollectionGroupFarmers: '/data-collection/groups',
  livelihoodTrainingModulesDropdown: '/trainings/modules/dropdown',

  // data collection new apis
  livelihoodDataCollectionFormsNew: '/data-collection/forms/',
  livelihoodDataCollectionFormsNewPatcH: '/data-collection/',

  //data collection images
  livelihoodDataCollectionImages: '/data-collection/gap-audit-reference-images/',

  //data collection fip traffic light
  livelihoodDataCollectionFipTrafficLight: '/data-collection/fip/',

  //Farmer Journeys
  farmerJourneys: '/farmer/journeys',
  farmerJourneysExport: '/farmer/journeys/export',
  farmerEventList: '/farmer/farmer-event-list',
  liCollectionCenter: '/farmer/li/collectionCenter',

  submitTrunkAnalysis: '/data-collection/trunk_analysis',
  submitTrunkSampling: '/data-collection/trunk_sampling',
  submitPlantAnalysis: '/data-collection/plant_analysis',
  submitSoilSampling: '/data-collection/soil_sampling',
  submitSoilAnalysis: '/data-collection/soil_analysis',
  submitSoilVerification: '/data-collection/soil_verification',
  submitVgm: '/data-collection/vgm',
  submitFertilizerRecommendation: '/data-collection/fertilizer_recommendation',
  submitFertilizerReceived: '/data-collection/fertilizer_received',
  submitGanodermaCensus: '/data-collection/ganoderma_census',
  submitGapAudit: '/data-collection/gap-audit',
  submitFarmMaintenance: '/data-collection/farm_maintenance',
  submitGapSamplePoint: '/data-collection/gap_audit_sample_point',
  deleteSamplingPoint: '/data-collection/sample-point/',

  verifyFarmerFarm: '/farmers/Farm-Verification',

  //livelihood api for program groups participants
  programGroupParticipants: '/program/with-farmers',
  programGroupByIdParticipants: '/program/farmers/',

  // Research APIs
  homeDashboard: '/reports/main-dashboard',
  researchDFWidgets: '/reports/research-diffusion-card',
  participantsBySurveyId: '/Participants/participants-by-survey',
  sendSurveyToParticipants: '/survey/send-survey-to-participants',
  getCollections: '/trace/collection-centre-summary',
  dfParticipants: '/participants',
  tvParticipants: '/trace/collection-centre/farmers',
  ccParticipants: '/data-collection/cc-farmersResearch',
  liParticipants: '/farmer',
  participantsById: '/reports/dashboard',
  getPillarFields: '/pillars/pillar-fields',
  getReportByColumns: '/reports',
  //livelihood api for data collection
  formsGetDataCollectionNew: '/data-collection/farm/',
  formsPutDataCollectionNewStatus: '/program/history/',

  //new endpoints for data collection Livelihood
  newDataCollectionGetFarmDetails: '/data-collection/farmers/',

  //new endpoint for cc assessment
  ccAssessmentGroups: '/assessment/assessment-cycle/groups',
  ccAssessmentGroupsParticipants: '/assessment/get-farmers/assessment-cycle/groups',
  //report new api
  exportReportData: '/reports/exportreport',

  //LI endpoints for approval
  cyclesLIapproval: '/assessment/cycle-approval-list',
  cyclesLIapprovalAction: '/assessment/cycle/action',

  deleteResearchSurvey: '/survey/delete-survey/',

  researchDFCard: '/reports/research-diffusion-dashboard-card',
  researchDashboardFarmcard: '/reports/researchDashboardFarmcard',
  researchDashboardFarm: '/reports/researchDashboardFarm',

  getPassword: '/users/generate-password',

  dfApprovalList: `/farmerjourney/v2/`,
};

const APIMethods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

const Exported = {
  Endpoints,
  APIMethods,
};

export default Exported;
